"use client";
import algoliasearch from "algoliasearch";
import { useEffect, useState } from "react";
import "react-multi-carousel/lib/styles.css";
import Link from "next/link";
import MultiCarousel from "../Carousels/MultiCarousel";
import classes from "./TopPicks.module.css";

const client =
  process.env.NEXT_PUBLIC_OG_DB === "true"
    ? algoliasearch(
        process.env.NEXT_PUBLIC_ALGOLIA_APPID,
        process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
      )
    : algoliasearch(
        process.env.NEXT_PUBLIC_DUMMY_ALGOLIA_APPID,
        process.env.NEXT_PUBLIC_DUMMY_ALGOLIA_API_KEY
      );

const MoreFromThisSeller = (props) => {
  const { sellerId, productId } = props;
  const [displayListings, setDisplayListings] = useState([]);

  const getUserListings = async (sellerId) => {
    const index = client.initIndex(
      process.env.NEXT_PUBLIC_OG_DB === "false"
        ? "kashew_listings"
        : `kashew_listings_branded_deals`
    );
    await index
      .search(sellerId, {
        hitsPerPage: 10,
        page: 0,
        filters: `status:active`,
        clickAnalytics: true,
      })
      .then(async (res) => {
        setDisplayListings(res.hits);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (sellerId && sellerId !== "" && sellerId !== "undefined") {
      getUserListings(sellerId);
    }
  }, []);

  return (
    <>
      {displayListings && displayListings?.length > 0 && (
        <div className={classes.margin}>
          <div className={classes.headerBox}>
            <h6 className={classes.header}>More from this seller</h6>

            <Link
              className={classes.Link}
              href={`/more-from-this-seller/${sellerId}?item=${productId}`}
            >
              <h6 className={classes.seeAll}>See all</h6>
            </Link>
          </div>
          <MultiCarousel listings={displayListings} />
        </div>
      )}
    </>
  );
};

export default MoreFromThisSeller;
